<script>
  import { AuthProviderButton } from '@storytel/design-system-web';
  import { l10n } from '../utils/Utils';
  import { createEventDispatcher } from 'svelte';
  import { socialLoginWeb } from '../services/SthpService';

  export let env;
  const dispatch = createEventDispatcher();

  let isConnected = false,
    facebookId = '',
    fbToken;

  document.onreadystatechange = () => {
    if (document.readyState === 'completed') {
      window.fbAsyncInit();
    }
  };

  window.fbAsyncInit = () => {
    FB.init({
      appId: '156162597852941',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v5.0',
    });

    try {
      FB.getLoginStatus((response) => {
        statusChangeCallback(response);
      });
    } catch (e) {
      console.log('Error when getting login status: ', e);
    }
  };

  const statusChangeCallback = (response) => {
    // The response object is returned with a status field that lets the
    // app know the current login status of the person.
    // Full docs on the response object can be found in the documentation
    // for FB.getLoginStatus().
    if (response.status === 'connected') {
      // Logged into your app and Facebook.
      isConnected = true;
      facebookId = response.authResponse.userID;
      fbToken = response.authResponse.accessToken;
    } else {
      // not_authorized: The person is logged into Facebook, but not Storytel.
      // unknown: Not logged in to Facebook.
      isConnected = false;
      fbToken = '';
    }
  };

  const facebookLoginIsConnected = () => {
    FB.login(
      (response) => {
        if (response.status === 'connected') {
          login(response.authResponse.userID, response.authResponse.accessToken);
        } else {
          dispatch('loginError', l10n('generic.error.contactSupport'));
        }
      },
      { scope: 'email' }
    );
  };

  const facebookLogin = () => {
    if (!isConnected) {
      facebookLoginIsConnected();
    } else {
      login(facebookId, fbToken);
    }
  };

  const login = async (fbId, fbToken) => {
    const result = await socialLoginWeb(env, fbId, fbToken);
    if (result.result === 'success' || result.result === 'redirectToAccountPage') {
      dispatch('loginSuccess');
    } else {
      dispatch('loginError', result.errorText);
    }
  };

</script>

<svelte:head>
  <script defer async crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js">
  </script>
</svelte:head>

<AuthProviderButton fullwidth on:click={() => facebookLogin()} type="facebook">
  {l10n('facebook.loginWith')}
</AuthProviderButton>
